/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_File_Deleted_SuccessInputs */



/**
* | output |
* | --- |
* | "Translation file deleted successfully" |
*
* @param {Translation_File_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_file_deleted_success = /** @type {((inputs?: Translation_File_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_File_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fichier de traduction supprimé avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersetzungsdatei erfolgreich gelöscht")
	if (locale === "it") return /** @type {LocalizedString} */ ("File di traduzione eliminato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Файл перевода успешно удален.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivo de traducción eliminado correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译文件已成功删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳ファイルが正常に削除されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद फ़ाइल सफलतापूर्वक हटा दी गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivo de tradução excluído com sucesso")
	return /** @type {LocalizedString} */ ("Translation file deleted successfully")
});